import futura from '../assets/futura.png'
import { Link } from 'react-router-dom';

function N7() {
    return (<>
        <div className="back-profilazione" style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="square-center">
     
                <div className="flex row center-con sp">
                    <h2 className="c">Richiesta completata!</h2><img src={futura} className="min-fut">
                    </img>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <p>Grazie per la prenotazione!</p>
                        <p>Torna presto a trovarci.</p>
                        <p></p>
                        <p><Link to="/">Torna alla Home</Link></p>
                        <p></p>
                    </div>
                </div>

            </div>
            <p style={{ marginTop: '40px', fontWeight: 300, marginBottom: '40px', textAlign: 'center' }}>In caso di necessit&agrave; puoi contattare un nostro operatore al numero<br /> <a href='tel:+3908119312726'>081 193 12 726</a> che ti aiutera nella prenotazione.</p>

        </div>
    </>
    );
}

export default N7;